import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

export type TSamlPlatform = 'spectrio' | 'elevEight';

export interface ISamlResponse {
    destination: string;
    base64: string;
}

const ENDPOINT = environment.api + '/saml/';

@Injectable({
    providedIn: 'root',
})
export class SamlHttpService {
    private http = inject(HttpClient);

    get(type: TSamlPlatform): Observable<ISamlResponse> {
        return this.http.get<ISamlResponse>(ENDPOINT + type);
    }
}
